$(document).ready(function () {
    const IDENTIFIER = "time_tracking_report";
    const pathReport = "/action/report/time-tracking";
    const pathExcelExportURL = "/action/report/excel/time-tracking-report";
    const fetchReportButton = $("div#fetch_" + IDENTIFIER + "_button");
    const storeSelect = $("select#" + IDENTIFIER + "_store_select");
    const reportDataWrapper = $("div#" + IDENTIFIER + "_data_wrapper");
    const dateInputs = $("input#" + IDENTIFIER + "_date_from, input#" + IDENTIFIER + "_date_to");
    const defaultButtonText = fetchReportButton.data("default-text") || $.trim(fetchReportButton.text());
    const loadingButtonText = fetchReportButton.data("loading-text") || defaultButtonText;


    let ajaxLockActive = false;

    initReportDatePickers();

    fetchReportButton.click(function (e) {
        if (ajaxLockActive){
            return false;
        }

        displayLoadingGifInButton()
        const data = getDataParameters();
        $.ajax({
            type: 'GET',
            url: pathReport,
            data: data,
            dataType: 'json'
        }).success(function (data) {
            removeLoadingGifFromButton();
            reportDataWrapper.html(data.report);
            mountScaleToFitViewport();
        }).error(function () {
            removeLoadingGifFromButton();
            console.log("error");
        });
    });

    $(document).on('click', 'div#' + IDENTIFIER + '_data_wrapper tr.user_row td', function () {
        // Toggle this tags product details
        let userId = $(this).closest('tr').attr('user_id');
        $('tr[parent_user_id="' + userId + '"]').each(function() {
            $(this).toggle();
        });
    });

    $(document).on('click', 'div#' + IDENTIFIER + '_data_wrapper a#time_tracking_download_excel_report_button', function () {
        createExcelFile();
        return false;
    });


    function createExcelFile() {
        if (ajaxLockActive) {
            return;
        }
        ajaxLockActive = true;

        $.ajax({
            type: 'GET',
            url: pathExcelExportURL,
            data: getDataParameters(),
            dataType: 'json'
        }).success(function (data) {
            window.location = '/includes/report/excels/' + data.excel_file_name;
        }).error(function (data) {
            // onError($.parseJSON(data.responseText).errors);
        }).always(function () {
            ajaxLockActive = false;
        });
    }


    function getDateFrom() {
        return $("input#" + IDENTIFIER + "_date_from").val();
    }
    function getDateTo() {
        return $("input#" + IDENTIFIER + "_date_to").val();
    }

    /**
     * Returns parameters sent to controller
     *
     * @returns
     */
    function getDataParameters() {
        let data = {
            from_date: getDateFrom(),
            to_date: getDateTo(),
        };

        if (storeSelect.length) {
            data.store_sync_code = storeSelect.val();
        }
        return data
    }

    function initReportDatePickers() {
        if (typeof flatpickr === 'undefined') {
            return;
        }

        dateInputs.each(function () {
            flatpickr(this, {
                allowInput: true,
                dateFormat: "d/m/Y",
                disableMobile: true
            });
        });
    }

    function mountScaleToFitViewport() {
        if (window.ScaleToFitViewport && typeof window.ScaleToFitViewport.mount === 'function') {
            window.ScaleToFitViewport.mount(reportDataWrapper);
        }
    }

    function displayLoadingGifInButton() {
        fetchReportButton.html('<img src="/includes/charts/gfx/ajax-loader.gif" alt="' + loadingButtonText + '" style="margin-right: 10px;"/> ' + loadingButtonText);
    }

    function removeLoadingGifFromButton() {
        fetchReportButton.html(defaultButtonText);
    }
});
